import axiosInstance from './axios';
import { apiBaseURL } from 'config/axios';
import { Storage } from '@capacitor/core';

export interface Token {
  access_token: string;
  token_type: string;
  expires_in: number;
}

export interface UserProfile {
  id: number;
  name: string;
  email: string;
  email_verified_at: Date;
  role: string;
  role_object: Role;
}

export interface Role {
  id: number;
  key: string;
  description: string;
}

const registrar = async (name, email, password, repetirPassword) => {
  const url = `${apiBaseURL}/auth/register`;
  await axiosInstance.post(url, {
    name,
    email,
    password,
    password_confirmation: repetirPassword
  });
}

const login = async (username, password) => {
  const url = `${apiBaseURL}/auth/login`;
  const response = await axiosInstance.post(url, {
    email: username,
    password: password,
  });
  if (response.data.access_token) {
    await Storage.set({ key: "token", value: JSON.stringify(response.data) });
    await fetchCurrentUserFromAPI();
  }
  return response.data;
}

const refreshToken = async () => {
  const url = `${apiBaseURL}/auth/refresh`;
  const response = await axiosInstance.post(url);
  if (response.data.access_token) {
    await Storage.set({ key: "token", value: JSON.stringify(response.data) });
    await fetchCurrentUserFromAPI();
  }
  return response.data;
}

const logout = async () => {
  await Storage.remove({ key: "token" });
  await Storage.remove({ key: "userProfile" });
  //localStorage.removeItem("user");
}

const isLoggedIn = async () => {
  const ret = await Storage.get({ key: "token" });
  const token: Token = JSON.parse(ret.value);
  return !!token;
}

const fetchCurrentUserFromAPI = async () => {
  const url = `${apiBaseURL}/auth/profile`;
  const response = await axiosInstance.get(url);
  const user: UserProfile = response.data;
  if (response.data) {
    await Storage.set({ key: "userProfile", value: JSON.stringify(user) })
  }
  return user;
}

const fetchCurrentUserFromStorage = async () => {
  const ret = await Storage.get({ key: "userProfile" });
  const userProfile: UserProfile = JSON.parse(ret.value);
  return userProfile;
}

const resetPasswordEmail = async (email) => {
  const url = `${apiBaseURL}/auth/password/email`;
  await axiosInstance.post(url, {
    email: email,
  });
}

const resetPassword = async (email, password, repetirPassword, token) => {
  const url = `${apiBaseURL}/auth/password/reset`;
  await axiosInstance.post(url, {
    email: email,
    password: password,
    password_confirmation: repetirPassword,
    token: token
  });
}

const changePassword = async (currentPassword, password, repetirPassword) => {
  const url = `${apiBaseURL}/auth/password/change`;
  await axiosInstance.post(url, {
    current_password: currentPassword,
    new_password: password,
    new_password_confirmation: repetirPassword,
  });
}

export default {
  isLoggedIn,
  registrar,
  login,
  logout,
  refreshToken,
  fetchCurrentUserFromAPI,
  fetchCurrentUserFromStorage,
  resetPasswordEmail,
  resetPassword,
  changePassword
}
